import type { ActionTypes as AppActionTypes } from './app'
import { Constants as AppConstants, Actions as AppActions } from './app'
// CONSTANTS
export const Constants = { ...AppConstants }
// ACTION TYPES
export type ActionTypes = AppActionTypes
// ACTION CALLS
export const Actions = { ...AppActions }